import "../styles/Footer.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import logo from "../assets/footer-logo.png";

import {
  FaFacebookF,
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
  FaInstagram,
  FaTiktok,
} from "react-icons/fa";

function Footer() {
  const { t } = useTranslation();

  const whatsappLink = "https://wa.me/201205585860";

  const callLink = "tel:+201205585860";

  const facebookLink =
    "https://www.facebook.com/share/1CkKahyXtT/";

  const instagramLink =
    "https://www.instagram.com/egyptian_international_?utm_source=qr";

  const tiktokLink =
    "https://www.tiktok.com/@egyption_international?_r=1&_t=ZS-97aWp97XzXO";

  const emailLink =
    "mailto:salesegyptianinternational@gmail.com";

  return (
    <footer className="footer" id="contact">

      <div className="footer-container">

        {/* LEFT: COMPANY INFO */}
        <div className="footer-col">

          <div className="footer-brand">

            <img
              src={logo}
              alt="EIFJB Logo"
              className="footer-brand-logo"
            />

            <h2 className="footer-logo">
              EIFJB
            </h2>

          </div>

          <p className="footer-text">
            {t("footer_description")}
          </p>

          {/* SOCIAL LINKS */}
          <div className="footer-socials">

            <a
              href={emailLink}
              className="social"
              title="Email"
            >
              <FaEnvelope />
            </a>

            <a
              href={callLink}
              className="social"
              title="Call"
            >
              <FaPhoneAlt />
            </a>

            <a
              href={facebookLink}
              className="social"
              target="_blank"
              rel="noreferrer"
              title="Facebook"
            >
              <FaFacebookF />
            </a>

            <a
              href={instagramLink}
              className="social"
              target="_blank"
              rel="noreferrer"
              title="Instagram"
            >
              <FaInstagram />
            </a>

            <a
              href={tiktokLink}
              className="social"
              target="_blank"
              rel="noreferrer"
              title="TikTok"
            >
              <FaTiktok />
            </a>

            <a
              href={whatsappLink}
              className="social"
              target="_blank"
              rel="noreferrer"
              title="WhatsApp"
            >
              <FaWhatsapp />
            </a>

          </div>

        </div>

        {/* MIDDLE: LINKS */}
        <div className="footer-col footer-links-modern">

          <Link to="/">
            {t("nav_home")}
          </Link>

          <Link to="/about">
            {t("nav_about")}
          </Link>

          <Link to="/products">
            {t("nav_products")}
          </Link>

          <Link to="/contact">
            {t("nav_contact")}
          </Link>

        </div>

        {/* RIGHT: MAP */}
        <div className="footer-col map-col">

          <h3 className="map-title">
            {t("footer_location")}
          </h3>

          <div className="map-wrapper">

            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d54699.84564160138!2d30.43153815499849!3d31.03348295648752!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14f66b44ab4d134d%3A0xd82c098442a59488!2sRaneen%20-%20Damanhour!5e0!3m2!1sen!2seg!4v1778974692679!5m2!1sen!2seg"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title={t("footer_map_title")}
            />

          </div>

        </div>

      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        © 2026 {t("footer_company")} - {t("footer_rights")}
      </div>

    </footer>
  );
}

export default Footer;